<script lang="ts">
  import type { InboxWorkflowCellProps } from "@kontextwerk/control-web-frame/shared/logic/inbox-workflow"
  import InboxContactCell from "../../../../../../_shared/_modules/inbox-contact-cell"
  import type {
    WrongRecipientSourceCleanupDraft,
    WrongRecipientSourceCleanupRow,
  } from "../../contract"
  let {
    row,
    disabled,
  }: InboxWorkflowCellProps<WrongRecipientSourceCleanupRow, WrongRecipientSourceCleanupDraft> =
    $props()
</script>

<InboxContactCell
  label={row.customerLabel}
  roleLabel={row.customerRole}
  email={row.customerEmail}
  phone={row.customerPhone}
  contactPoints={row.customerContactPoints}
  unitLabel={row.unitLabel}
  {disabled}
/>
